import { render } from "./PageSignin.vue?vue&type=template&id=3c2a737c"
import script from "./PageSignin.vue?vue&type=script&lang=js"
export * from "./PageSignin.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__